
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  title: 'User experience',
  section: 'User experience',
  layout: 'guide',
  description: 'Plaid User Experience guide',
  preloadImages: [{
    src: '/assets/img/exchange/docs/web-authn-example-flow.gif',
    type: 'image/gif'
  }]
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Image = makeShortcode("Image");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='User Experience' subtitle={metadata.description} mdxType="Header"></Header>
    <p><a parentName="p" {...{
        "href": "https://plaid.com/docs/link/"
      }}>{`Plaid Link`}</a>{` is the UI component users interact with to link their accounts to an app using Plaid.
Your institution will show up in Plaid Link after you go live on Plaid Exchange.`}</p>
    <h2 {...{
      "id": "institution-select"
    }}>{`Institution select`}</h2>
    <p>{`A user wants to connect their financial account to an app called WonderWallet.
WonderWallet sends them to Plaid Link where they can select their financial institution.
In this example, the financial institution is called First Platypus Bank.`}</p>
    <Image src='/assets/img/exchange/docs/oauth-example-wonderwallet.png' alt='OAuth Example' mdxType="Image" />
    <h2 {...{
      "id": "oauth-authentication"
    }}>{`OAuth authentication`}</h2>
    <p>{`The user is asked to authenticate with First Platypus.
Plaid recommends you do this using the OAuth 2.0 protocol.`}</p>
    <p>{`You own the OAuth user experience and host it on your domain.
We encourage you have two screens with your logo prominently featured: a login screen and two-step verification screen.`}</p>
    <Image src='/assets/img/exchange/docs/oauth-authentication.png' alt='OAuth Authentication Example Login Page' mdxType="Image" />
    <h2 {...{
      "id": "app2app"
    }}>{`App2App`}</h2>
    <p>{`If you have a native mobile application, Plaid strongly recommends enabling App2App authentication in order to enable a more secure and seamless consumer authentication experience.
The example below uses an App2App flow.
The user is brought to the First Platypus app to authenticate where they can use biometrics.`}</p>
    <Image src='/assets/img/exchange/docs/app2app-example-flow.gif' alt='App2App Example Login Page]' mdxType="Image" />
    <h2 {...{
      "id": "webauthn"
    }}>{`WebAuthn`}</h2>
    <p>{`We also recommend using `}<a parentName="p" {...{
        "href": "https://webauthn.io/"
      }}>{`WebAuthn`}</a>{` for web-based authentication.
Users can enroll and then easily use biometrics to authenticate on any web browser.`}</p>
    <Image src='/assets/img/exchange/docs/web-authn-example-flow.gif' alt='WebAuthn Biometric Login Example' mdxType="Image" />
    <h2 {...{
      "id": "account-selection"
    }}>{`Account selection`}</h2>
    <p>{`If the user has more than one financial account, the user returns to Plaid Link and is asked to select which accounts they’d like to link.
The user then sees a success screen.
Tapping the continue button will return them to WonderWallet.`}</p>
    <Image src='/assets/img/exchange/docs/oauth-example-account-selection.png' alt='Account Selection Example' mdxType="Image" />
    <h2 {...{
      "id": "returning-user-experience"
    }}>{`Returning user experience`}</h2>
    <p>{`The returning user experience (RUX) streamlines onboarding for users who have previously connected a financial account with Plaid via your institution’s OAuth and API integration.
For returning users who have been verified by Plaid, we can enable them to securely authenticate their account in fewer steps.`}</p>
    <p>{`A user must connect their account through your OAuth flow before they are eligible for Plaid’s returning user experience.
When the same user wants to connect their account to another app, Plaid enables the user to do so in a secure way via Plaid Link-based authentication methods like biometrics, One-time Passcodes, etc.
This is supplemented with both internal and external security mechanisms such as browser, network, and device fingerprinting.`}</p>
    <p>{`As a data partner for Plaid Exchange, you’re automatically enabled for RUX with no integration work required.
Your eligible users can now benefit from a faster way to securely connect their accounts to apps and services on the Plaid network.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "institution-select",
        level: 2,
        title: "Institution select",
      },
{
        id: "oauth-authentication",
        level: 2,
        title: "OAuth authentication",
      },
{
        id: "app2app",
        level: 2,
        title: "App2App",
      },
{
        id: "webauthn",
        level: 2,
        title: "WebAuthn",
      },
{
        id: "account-selection",
        level: 2,
        title: "Account selection",
      },
{
        id: "returning-user-experience",
        level: 2,
        title: "Returning user experience",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
